import React, { forwardRef, PropsWithChildren } from 'react';
import { SxProps, Typography, TypographyProps } from '@mui/material';

type Props = PropsWithChildren<
  {
    sx?: SxProps;
    className?: string;
  } & Pick<TypographyProps, 'component'>
>;

export const Body1 = ({ children, sx, className, component = 'p' }: Props) => {
  return (
    <Typography
      component={component}
      className={className}
      sx={{
        color: 'var(--dk-text, #000)',
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: '24px',
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
};

export const Body2 = forwardRef<HTMLParagraphElement, Props>(
  ({ children, sx, className, component = 'p', ...rest }, ref) => {
    return (
      <Typography
        ref={ref}
        className={className}
        component={component}
        sx={{
          margin: 0,
          padding: 0,
          color: 'var(--dk-text-secondary, #888D96)',
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '20px',
          ...sx,
        }}
        {...rest}
      >
        {children}
      </Typography>
    );
  },
);

Body2.displayName = 'Body2';

export const Caption = ({
  children,
  sx,
  className,
  component = 'p',
}: Props) => {
  return (
    <Typography
      className={className}
      component={component}
      sx={{
        color: 'var(--dk-text-secondary, #888D96)',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '18px',
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
};
